export class PersistProvider {
    constructor(persistStoreProvider, accessControlProvider, persistedValueConfigurationProvider) {
        this.persistStoreProvider = persistStoreProvider;
        this.accessControlProvider = accessControlProvider;
        this.persistedValueConfigurationProvider = persistedValueConfigurationProvider;
    }
    annotateKey(key) {
        return this.accessControlProvider.getAccessControlledKey(key);
    }
    get(key) {
        const rawPersistedValue = this.persistStoreProvider.get(this.annotateKey(key));
        return this.persistedValueConfigurationProvider.getValue(rawPersistedValue);
    }
    set(key, value, ttl) {
        const rawPersistedValue = this.persistedValueConfigurationProvider.createRawPersistedValue(key, value, ttl);
        this.persistStoreProvider.set(this.annotateKey(key), rawPersistedValue);
    }
}
//# sourceMappingURL=PersistProvider.js.map